import { useCallback } from 'react'

import { useUserOrganizationMembership } from '@modules-deprecated/app/organization/hooks/useUserOrganizationMembership'

import { LocalStorageKeys } from '../../../enums/localStorageKeys'
import { advisorActorType, advisorAppArea } from '../constants'
import type { AdvisorActorType, AdvisorAppArea } from '../types'

interface AdvisorTrackingProperties {
  actorType: AdvisorActorType
  appArea: AdvisorAppArea
  cpaId: string | undefined
}

export const useAdvisorTrackingProperties = (ownerUmbrellaId?: string): (() => AdvisorTrackingProperties) => {
  const { membership, isViaUmbrella } = useUserOrganizationMembership()

  return useCallback((): AdvisorTrackingProperties => {
    const advisorLayerMode = (() => {
      try {
        return localStorage.getItem(LocalStorageKeys.AdvisorLayerMode)
      } catch {
        return null
      }
    })()

    const umbrellaUrlId = window.location.pathname.match(/\/umbrellas\/([^/]+)/)?.[1]
    const isUmbrellaUrl = !!umbrellaUrlId
    const isCpa = isUmbrellaUrl || (isViaUmbrella && membership?.via !== 'direct')
    const actorType: AdvisorTrackingProperties['actorType'] = isCpa ? advisorActorType.Cpa : advisorActorType.Customer
    const isExpertMode = isCpa && advisorLayerMode === 'expert'

    const appArea: AdvisorTrackingProperties['appArea'] = (() => {
      if (isUmbrellaUrl) {
        return advisorAppArea.Practice
      }
      if (isExpertMode) {
        return advisorAppArea.Expert
      }
      return advisorAppArea.Client
    })()

    const cpaId: AdvisorTrackingProperties['cpaId'] = isCpa ? (ownerUmbrellaId ?? umbrellaUrlId) : undefined

    return { actorType, appArea, cpaId }
  }, [isViaUmbrella, membership?.via, ownerUmbrellaId])
}
